const html = html => ({ __html: html });

export default html;
